module.exports = __webpack_public_path__ + "img/daily-tournament-bg_460.02384dda.png";